// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 POST /api/challenge */
export async function challengeControllerCreate(
	body: API.ChallengeCreateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/challenge', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/challenge/${param0} */
export async function challengeControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.ChallengeControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.ChallengeViewResponse[]>(`/api/challenge/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/challenge/done */
export async function challengeControllerDone(
	body: API.ChallengeDoneRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/challenge/done', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/challenge/remove */
export async function challengeControllerRemove(
	body: API.ChallengeDeleteRequest[],
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/challenge/remove', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}
